import React, {useEffect, useMemo, useRef, useState} from 'react';
import {useStore} from "../../../../stores/StoreHelpers";
import useAPI from "../../../../hooks/useAPI";
import {useHistory, useParams, useNavigate} from "react-router-dom";
import useToast from "../../../../hooks/useToast";
import {useRequestObject} from "../../../../hooks/useRequestObject";
import {IncomesRequests} from "../../../../requests/PortfolioRequests/IncomesRequests";
import useURLSearchParams from "../../../../hooks/useURLSearchParams";
import {observer} from "mobx-react";
import InnerPageComponent from "../../../../pages/project/PortfolioProject/InnerPageComponent";
import {Button, Card, Col, Form, Row} from "react-bootstrap";
import AsyncSelect from "react-select/async";
import SelectWithCustomInput from "../../../SelectWithCustomInput/SelectWithCustomInput";
import {newYears, years} from "../../../../helpers";
import Select from "react-select";
import style from './style.module.less'
import StatusBadge from "../../../common/StatusBadge";
import ConfirmModal from "../../../common/ConfirmModal";
import Required from "../../../Required";
import HeadSelectComponent from "../../../HeadSelectComponent/HeadSelectComponent";
import SelectInput from "../../../SelectInput/SelectInput";
import {getActionsModel} from "../../../../services/roles/factdataRoleStatus";
import useUserContext from "../../../../hooks/useUserContext";
import {ArticlesRequests} from "../../../../requests/PortfolioRequests/articlesRequests";

const IncomesForm = observer(() => {

    const store = useStore().incomeProj
    const api = useAPI()
    const userCtx = useUserContext();
    let {projId, stratId, portfolioId, incomeId} = useParams()
    const [getParamIsEdit, setParamIsEdit] = useURLSearchParams('isEdit');
    const [isEdit, setIsEdit] = useState(getParamIsEdit() === 'true' || !!Number(incomeId) || !!store.formObject?.id)
    const [confirmModalOpen, setConfirmModalOpen] = useState(false)
    const [validated, setValidated] = useState(false)
    const formEl = useRef(null);

    const addToast = useToast()
    const history = useHistory()
    // const requests = useRequestObject(new IncomesRequests(api, toast, store, projId, +portfolioId, +stratId))
    const requests = useRequestObject({classType:IncomesRequests,api,addToast,store,portfolioId,stratId,projId})

    const optionsResultsYear = [...newYears.map((val, index) => {
        return {value: val, label: val}
    })]
    const can = useMemo(() => getActionsModel(store.formObject?.status, userCtx, stratId, portfolioId, projId ?? store.formObject?.projId), [store.formObject, userCtx]);

    useEffect(() => {
        const currentParamIsEdit = getParamIsEdit() === 'true'
        setIsEdit(currentParamIsEdit);
    }, [getParamIsEdit])

    useEffect(() => {
        // setIsEdit(!!store.formObject?.id)
        !!store.formObject?.id && setParamIsEdit('true')
    }, [store.formObject?.id])

    useEffect(() => {
        if (!!Number(incomeId)) {
            requests.getIncomeById(incomeId)
                .then(x => store.setFormObject(x.income))
        } else {
            setParamIsEdit('false')
        }
    }, [])


    return (<React.Fragment>
            <InnerPageComponent
            projId={projId}
            header={!!isEdit ? 'Редактировать объем дохода' : 'Добавить объем дохода'}
            backAction={() => {
                new Promise(resolve => {
                    resolve(history.goBack())
                })
                    .then(() => store.clearIncomeOnExitCard())
            }}
        >
            <Form noValidate validated={validated} ref={formEl}
                  onSubmit={(event) => requests.saveIncome(store.formObject?.id ?? Number(incomeId), event, formEl, (val) => setValidated(val))}>

                <span onClick={() => setParamIsEdit('true')}>{isEdit}</span>
                <div className={style.cardContainer}>
                    <Card className={style.incomeCardForm}>
                        <Card.Header className={style.cardHeader}>
                            <div>Доходы</div>
                            <div style={{display: 'flex', gap: '20px'}}>
                                <StatusBadge type={'income'}
                                             status={store.formObject?.status ?? 'isCreating'}/>
                                {/*{*/}
                                {/*    (can.Delete && !!isEdit && store.formObject?.status) &&*/}
                                {/*    <div*/}
                                {/*        onClick={() => {*/}
                                {/*            (!!store.formObject?.status && store.formObject?.status !== 'isCreating')*/}
                                {/*            && setConfirmModalOpen(!confirmModalOpen)*/}
                                {/*        }} className={style.closeButton}>*/}
                                {/*    </div>}*/}
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <div className={style.bodyContainer}>
                                <Row className={'col-12'}>
                                    <Form.Group as={Col} className={'col-5'}>
                                        <HeadSelectComponent
                                            disabled={!can.Edit}
                                            required={true}
                                            label={'Руководитель темы'}
                                            classNamePrefix={store.selectorsStatuses.head}
                                            value={store.formObject?.head?.id
                                                ? {
                                                    value: store.formObject?.head?.id,
                                                    label: `${store.formObject?.head?.label}`
                                                }
                                                : null}
                                            loadOptions={requests.getTeamMembers}
                                            onChange={(val) => store.updateFormObject(val, 'head')}/>

                               </Form.Group>
                               <Form.Group as={Col}className={'col-7'}>
                                   <SelectWithCustomInput
                                       disabled={!can.Edit}
                                       required={true}
                                       label={'Институт (где работает руководитель темы)'}
                                       classNamePrefix={store.selectorsStatuses.institute}
                                       value={store.formObject?.institute
                                           ? store.formObject?.institute?.id
                                               ? {value:store.formObject?.institute?.id,label:`${store.formObject?.institute.label}` }
                                               : {value:null,label:`${store.formObject?.institute?.label}` }
                                           : null}
                                       placeholder="Выберите институт из списка или введите свое значение."
                                       defaultOptions={true}
                                       defaultValue={[]}
                                       loadOptions={requests.getInstitutes}
                                       onInputChange={(selectedValue)=>{
                                               store.updateFormObject({label:selectedValue},'institute')
                                       }}
                                       onChange={(val)=>store.updateFormObject(val,'institute')}
                                   />

                                    </Form.Group>
                                </Row>
                                <Row className={'col-12'}>
                                    <Form.Group as={Col}>
                                        <Form.Label style={{color: '#7F7F7F'}}>Наименование
                                            темы <Required/></Form.Label>
                                        <Form.Control
                                            disabled={!can.Edit}
                                            as={'input'}
                                            required
                                            name={'topic'}
                                            value={store.formObject?.topic ?? ''}
                                            onChange={(event) => store.updateFormObject(event.target.value, event.target.name)}
                                        />
                                    </Form.Group>
                                </Row>
                                <Row className={'col-12'}>
                                    <Col className={'col-5 d-flex flex-row'} style={{gap: '20px'}}>
                                        <Form.Group as={Col}>
                                            <Form.Label style={{color: '#7F7F7F'}}>Номер темы <Required/></Form.Label>
                                            <Form.Control
                                                disabled={!can.Edit}
                                                required
                                                name={'topicNum'}
                                                value={store.formObject?.topicNum ?? ''}
                                                onChange={(event) => store.updateFormObject(event.target.value, event.target.name)}
                                            />
                                        </Form.Group>
                                        <Form.Group as={Col}>
                                            <Form.Label style={{color: '#7F7F7F'}}>Год
                                                реализации <Required/></Form.Label>
                                            <SelectInput
                                                disabled={!can.Edit}
                                                placeholder={''}
                                                classNamePrefix={store.selectorsStatuses.year}
                                                noOptionsMessage={() => 'Ничего не найдено'}
                                                loadingMessage={() => 'Поиск...'}
                                                defaultOptions={optionsResultsYear}
                                                value={!store.formObject?.year ? null: {value:store.formObject?.year,label:store.formObject?.year}}
                                                onChange={(val) => {
                                                    store.updateFormObject(val.value, 'year')
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Form.Group as={Col} className={'col-7'}>
                                        <SelectWithCustomInput
                                            disabled={!can.Edit}
                                            label={'Тип дохода'}
                                            required={true}
                                            classNamePrefix={store.selectorsStatuses.type}
                                            value={(store.formObject?.type)
                                                ? {
                                                    value: store.formObject?.type.value,
                                                    label: `${store.formObject?.type?.label}`
                                                }
                                                : null
                                            }
                                            placeholder="Выберите тип дохода из списка или введите свое значение."
                                            defaultOptions={true}
                                            defaultValue={[]}
                                            loadOptions={requests.getIncomeTypes}
                                            onInputChange={(selectedValue) => {
                                                store.updateFormObject({
                                                    value: selectedValue,
                                                    label: selectedValue
                                                }, 'type')
                                            }}
                                            onChange={(val) => {
                                                store.updateFormObject(val, 'type')}}
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} >
                                        <Form.Label style={{color:'#7F7F7F'}}>Год реализации <Required/></Form.Label>
                                        <SelectInput
                                            disabled={!can.Edit}
                                            placeholder={''}
                                            classNamePrefix={store.selectorsStatuses.year}
                                            noOptionsMessage={() => 'Ничего не найдено'}
                                            loadingMessage={() => 'Поиск...'}
                                            defaultOptions={optionsResultsYear}
                                            value={!store.formObject?.year ? null: {value:store.formObject?.year,label:store.formObject?.year}}
                                            onChange={(val) =>{
                                                store.updateFormObject(val.value,'year')
                                            }} />
                                        </Form.Group>
                                </Row>
                                <Row className={'col-12'}>
                                    <Form.Group as={Col}>
                                        <Form.Label style={{color: '#7F7F7F'}}>Заказчик <Required/></Form.Label>
                                        <Form.Control
                                            disabled={!can.Edit}
                                            required
                                            name={'customer'}
                                            value={store.formObject?.customer ?? ''}
                                            onChange={(event) => store.updateFormObject(event.target.value, event.target.name)}
                                        />
                                    </Form.Group>
                                </Row>
                                <Row className={'col-5'}>
                                    <Form.Group as={Col}>
                                        <Form.Label style={{color: '#7F7F7F'}}>Объем реализации за отчетный год (тыс.
                                            руб.) <Required/></Form.Label>
                                        <Form.Control
                                            required
                                            disabled={!can.Edit}
                                            min={0}
                                            type={'number'}
                                            name={'salesVolume'}
                                            value={store.formObject?.salesVolume ?? ''}
                                            onChange={(event) => (!Number.isNaN(event.target.value)) && store.updateFormObject(event.target.value, event.target.name)}
                                        />
                                    </Form.Group>
                                </Row>
                            </div>
                        </Card.Body>
                    </Card>
                    <Card className={style.incomeCardButtons}>
                        <Card.Body>
                            <div className={style.buttonCardWithArticle}>
                                <Button type={'button'} variant={'outline-secondary'}
                                        onClick={() => history.goBack()}>Отменить</Button>
                                {can.Edit && <Button type={'submit'} variant={'outline-primary'}>Сохранить</Button>}
                                {(can.Delete && !!isEdit) && <Button onClick={() => setConfirmModalOpen(!confirmModalOpen)}>Удалить</Button>}

                                {can.Send && <Button type={'button'} variant={'primary'}
                                                  onClick={() => requests.sendIncome(Number(store.formObject.id))}>Отправить на согласование</Button>}
                            </div>
                        </Card.Body>
                    </Card>
                </div>
            </Form>
        </InnerPageComponent>
            {isEdit && <ConfirmModal show={confirmModalOpen}
                                     headerText={'Подтверждение операции'}
                                     onConfirm={() => requests.deleteIncomeById(store.formObject?.id ?? Number(incomeId)).then(() => history.goBack())}
                                     onClose={() => setConfirmModalOpen(!confirmModalOpen)}
                                     message={'Данные о текущем доходе будут удалены. Вы уверены?'}/>}
        </React.Fragment>
    );
});

export default IncomesForm;
